var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"measure-result"},[_vm._v("\n    LENGTH: "+_vm._s(_vm.distance)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"measure-result"},[_vm._v("\n    AREA: "+_vm._s(_vm.area)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c28dd9d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/measuretool/MeasureResult.vue
// module id = UF2A
// module chunks = 1